import mixpanel from 'mixpanel-browser';

import {
  GoogleAuthPayload,
  GoogleAuthResponse,
  SignUpPayload,
  SignUpResponse,
} from '@internal/types/api';

import { httpClient, mutationEndpoint } from '../system';
import { SIGNUP_REGISTER_API_PATH } from './constants';

const signup = mutationEndpoint({
  actionName: 'signup',
  mutationKey: ['sign-up'],
  mutationFn: (payload: SignUpPayload) =>
    httpClient.auto<SignUpResponse>({
      url: SIGNUP_REGISTER_API_PATH,
      method: 'POST',
      data: payload,
      headers: {
        'x-mixpanel-id': mixpanel.get_distinct_id().replace('$device:', ''),
      },
    }),
});

const googleAuth = mutationEndpoint({
  actionName: 'googleAuth',
  mutationKey: ['google-auth'],
  mutationFn: (payload: GoogleAuthPayload) =>
    httpClient.auto<GoogleAuthResponse>({
      url: '/api/signup/google-auth',
      method: 'POST',
      data: payload,
    }),
});

export { googleAuth, signup };
